import { stripInlineMarkup } from '../../services/stripInlineMarkup';

/**
 * Store description HTML → plain text, keeping paragraph and list breaks.
 *
 * Shared by the store-catalogue scrapers (Square Online, WooCommerce). Specs on
 * these shops are usually a bullet list or a label/value table inside the
 * description, which the AI enrich step reads, so the line structure is worth
 * keeping. Each line goes through `stripInlineMarkup`, which removes any
 * leftover inline tags and decodes entities — named and numeric (`&#8211;`).
 */
export function storeDescriptionText(html: string | null | undefined): string | undefined {
  if (!html) return undefined;
  const text = html
    .replace(/<\s*br\s*\/?>/gi, '\n')
    .replace(/<\/\s*(p|div|li|h[1-6]|tr|td|th|dt|dd)\s*>/gi, '\n')
    .replace(/<\s*li[^>]*>/gi, '- ')
    .replace(/<[^>]+>/g, '')
    .split('\n')
    .map((line) => stripInlineMarkup(line))
    // One line per paragraph / list item / spec cell. Blank lines are dropped:
    // `<br>` + a literal newline inside a spec table otherwise splits every
    // label from its value with an empty line.
    .filter(Boolean)
    .join('\n')
    .trim();
  return text || undefined;
}
